export const APP_ROUTES = {
  HOME: "/",
  APP_ORGANIZATION: "/app/organizations",
  ORGANIZATION_DETAIL: "/app/organization/detail/{organizationId}",
  ORDERLOGS: "/app/logs/{organizationId}",
  QUOTES: "/app/quotes",
  QUOTE_DETAIL: "/app/quotes/{quoteId}",
  NEW_CUSTOMER_QUOTE: "/app/quotes/new/customer",
  NEW_PROSPECT_QUOTE: "/app/quotes/new/prospect",
  COPY_QUOTE: "/app/quotes/{quoteId}/copy",
};
